export default __webpack_public_path__ + "static/media/pkb-2.49a02fbe.png";